import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { Input, InputNumber, Radio, Select, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { Save, Trash2, X } from 'react-feather';
import {
  saveOperationDataDiagram,
  tenantAttributeInfos,
} from '../../pages/Attribute/AttributeSlice';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const ModalDiagram = ({
  deviceId,
  numberKey,
  isDraw,
  isEdit,
  isDelete,
  setEdit,
  setDelete,
  show,
  setShow,
  startPoint,
  endPoint,
  dataDiagram,
  arrMachine,
  setArrMachine,
  width,
  height,
  refImage,
  handleSaveFrequency,
  inverter,
  setInverter,
  screenPositionX,
  setScreenPositionX,
  screenPositionY,
  setScreenPositionY,
}) => {
  const { t } = useTranslation();
  const refCanvas = useRef();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const [type, setType] = useState('');
  const [number, setNumber] = useState(null);
  const [label, setLabel] = useState('');
  const [unit, setUnit] = useState('');
  const [widthCanvas, setWidthCanvas] = useState();
  const [heightCanvas, setHeightCanvas] = useState();
  const [widthScreenshot, setWidthScreenshot] = useState(0);
  const [heightScreenshot, setHeightScreenshot] = useState(0);
  const [startX, setStartX] = useState();
  const [startY, setStartY] = useState();
  const [topLeftPoint, setTopLeftPoint] = useState();
  const [dataMachineDiagram, setDataMachineDiagram] = useState();
  const [status, setStatus] = useState('');
  const [frequency, setFrequency] = useState();

  const editPoint = dataDiagram?.filter(
    (item) => item.topLeftPoint.x === numberKey
  );

  // handle screenshot
  function FindPosition(oElement) {
    if (typeof oElement.offsetParent != 'undefined') {
      for (var posX = 0, posY = 0; oElement; oElement = oElement.offsetParent) {
        posX += oElement.offsetLeft;
        posY += oElement.offsetTop;
      }
      return [posX, posY];
    } else {
      return [oElement.x, oElement.y];
    }
  }

  useEffect(() => {
    if (refCanvas.current) {
      if (dataDiagram?.length > 0) setDataMachineDiagram(dataDiagram);
      if (isDraw) {
        setStartX(startPoint.x < endPoint.x ? startPoint.x : endPoint.x);
        setStartY(startPoint.y < endPoint.y ? startPoint.y : endPoint.y);
      }

      setWidthCanvas(refCanvas.current.offsetWidth);
      setHeightCanvas(refCanvas.current.offsetHeight);
    }
  }, [refCanvas.current, show]);

  useEffect(() => {
    if ((isDelete || isEdit) && dataDiagram?.length > 0) {
      if (editPoint?.length > 0) {
        setWidthScreenshot(editPoint[0].widthScreenshot * width);
        setHeightScreenshot(editPoint[0].heightScreenshot * height);
        setStartX(editPoint[0].topLeftPoint.x);
        setStartY(editPoint[0].topLeftPoint.y);
        setType(editPoint[0].type);
        setNumber(editPoint[0].number);
        setLabel(editPoint[0].label);
        setUnit(editPoint[0].unit);
        setFrequency(inverter[editPoint[0].number - 1]);
      }
    }
  }, [isEdit, isDelete]);

  useEffect(() => {
    if (refCanvas.current) {
      const realWidth = refImage.current.naturalWidth;
      const realHeight = refImage.current.naturalHeight;

      const rw = width / realWidth;
      const rh = height / realHeight;

      if (isDraw) {
        setWidthScreenshot(Math.abs(endPoint?.x - startPoint?.x));
        setHeightScreenshot(Math.abs(endPoint?.y - startPoint?.y));
      }

      const ImgPos = FindPosition(refImage.current);

      if (refImage.current) {
        const ctx = refCanvas.current.getContext('2d');
        setScreenPositionX(ImgPos[0]);
        setScreenPositionY(ImgPos[1]);

        setTopLeftPoint({
          x: (startX - ImgPos[0]) / rw,
          y: (startY - ImgPos[1]) / rh,
        });
        ctx.drawImage(
          refImage.current,
          isEdit ? startX : (startX - ImgPos[0]) / rw,
          isEdit ? startY : (startY - ImgPos[1]) / rh,
          widthScreenshot,
          heightScreenshot,
          0,
          0,
          widthCanvas,
          heightCanvas
        );
      }
    }
  }, [refCanvas.current, show, widthScreenshot, widthCanvas, isEdit, isDelete]);

  // choose info
  const handleSelectedType = (e) => {
    setType(e.target.value);
    setNumber(null);
    setLabel('');
    setStatus('');
  };

  // close modal
  const handleClose = () => {
    setShow(false);
    setWidthScreenshot();
    setDelete(false);
  };

  // handle SAVE
  const handleSaveMachine = async () => {
    if (
      label === '' ||
      (number === null && type !== 'pt') ||
      (!frequency && type === 'vf')
    )
      setStatus('error');
    else {
      if (isDraw) {
        // Draw
        const newArr = {
          type: type,
          number: number,
          label: label,
          unit: unit,
          topLeftPoint: topLeftPoint,
          topRightPoint: {
            x:
              Math.abs(
                (startPoint.x > endPoint.x ? startPoint.x : endPoint.x) -
                  screenPositionX
              ) / width,
            y: Math.abs(startY - screenPositionY) / height,
          },
          widthScreenshot: widthScreenshot / width,
          heightScreenshot: heightScreenshot / height,
          screenPosition: {
            x: screenPositionX,
            y: screenPositionY,
          },
        };

        const existingIndex = arrMachine.findIndex(
          (elm) => elm.type === type && elm.number === number
        );

        if (existingIndex !== -1) {
          const updatedArrMachine = [...arrMachine];
          updatedArrMachine[existingIndex] = newArr;
          setArrMachine(updatedArrMachine);
        } else {
          setArrMachine([...arrMachine, newArr]);
        }
      } else if (isEdit && !isDelete) {
        // Edit
        let newArr = {
          type: type,
          number: number,
          label: label,
          unit: unit,
          topLeftPoint: editPoint[0].topLeftPoint,
          topRightPoint: editPoint[0].topRightPoint,
          widthScreenshot: editPoint[0].widthScreenshot,
          heightScreenshot: editPoint[0].heightScreenshot,
          screenPosition: {
            x: screenPositionX,
            y: screenPositionY,
          },
        };

        let index = dataMachineDiagram.findIndex(
          (elm) => elm.type === type && elm.number === number
        );

        let arrMachine = [...dataMachineDiagram];
        arrMachine[index] = newArr;

        let newInverter = [...inverter];
        newInverter[number - 1] = frequency;
        setInverter(newInverter);

        const filteredData = [];
        const seen = {};

        for (let i = 0; i < arrMachine.length; i++) {
          const item = arrMachine[i];
          const key = `${item.type}_${item.number}`;

          if (!seen[key]) {
            seen[key] = true;
            filteredData.push(item);
          }
        }

        dispatch(
          saveOperationDataDiagram({
            token,
            deviceId,
            arrMachine: filteredData,
          })
        );
        setTimeout(() => {
          setArrMachine(filteredData);
          dispatch(tenantAttributeInfos({ token }));
        }, 1000);
      } else {
        // Delete
        let index = dataMachineDiagram.findIndex(
          (elm) => elm.type === type && elm.number === number
        );
        let arrMachine = [...dataMachineDiagram];
        arrMachine.splice(index, 1);

        const filteredData = [];
        const seen = {};

        for (let i = 0; i < arrMachine.length; i++) {
          const item = arrMachine[i];
          const key = `${item.type}_${item.number}`;

          if (!seen[key]) {
            seen[key] = true;
            filteredData.push(item);
          }
        }

        dispatch(
          saveOperationDataDiagram({
            token,
            deviceId,
            arrMachine: filteredData,
          })
        );
        setTimeout(() => {
          setArrMachine(filteredData);
          dispatch(tenantAttributeInfos({ token }));
        }, 500);
      }
      handleSaveFrequency(number, frequency);

      // close diagram
      setWidthScreenshot();
      setEdit(false);
      setDelete(false);
      setShow(false);
    }
  };

  const handleSelected = (index) => {
    setNumber(index);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{isDraw ? 'Thêm' : isDelete ? 'Xoá' : 'Sửa'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={4}>
            <canvas
              ref={refCanvas}
              style={{ border: '1px solid #ced4da', borderRadius: '5px' }}
              width={200}
              height={260}
            ></canvas>
          </Col>
          <Col md={8}>
            <Form className="mr-4">
              <Row>
                <Radio.Group
                  onChange={handleSelectedType}
                  disabled={isDelete}
                  value={type}
                >
                  <Space direction="vertical">
                    {/* Pump */}
                    <Radio value="pump">{t('pump')}</Radio>
                    {type === 'pump' && (
                      <Space style={{ marginLeft: 24 }}>
                        <Select
                          defaultValue={number}
                          disabled={isDelete}
                          style={{ width: 100 }}
                          onChange={(e) => handleSelected(e)}
                          defaultOpen
                          status={status}
                        >
                          {[...Array(16)].map((item, index) => (
                            <Option
                              key={index}
                              value={index + 1}
                              title={index + 1}
                              disabled={(isDraw
                                ? arrMachine
                                : dataMachineDiagram
                              )?.find(
                                (item) =>
                                  (item.type === 'pump' ||
                                    item.type === 'vf' ||
                                    item.type === 'van') &&
                                  item.number === index + 1
                              )}
                            />
                          ))}
                        </Select>
                        <Input
                          disabled={isDelete}
                          defaultValue={label}
                          style={{ width: 200, marginLeft: 5 }}
                          onChange={(e) => setLabel(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('maxLength10Char')}
                          addonBefore={t('label')}
                        />
                      </Space>
                    )}

                    {/* Van */}
                    <Radio value="van">{t('Van')}</Radio>
                    {type === 'van' && (
                      <Space style={{ marginLeft: 24 }}>
                        <Select
                          defaultValue={number}
                          disabled={isDelete}
                          style={{ width: 100 }}
                          onChange={(e) => handleSelected(e)}
                          defaultOpen
                          status={status}
                        >
                          {[...Array(16)].map((item, index) => (
                            <Option
                              key={index}
                              value={index + 1}
                              title={index + 1}
                              disabled={(isDraw
                                ? arrMachine
                                : dataMachineDiagram
                              )?.find(
                                (item) =>
                                  (item.type === 'pump' ||
                                    item.type === 'vf' ||
                                    item.type === 'van') &&
                                  item.number === index + 1
                              )}
                            />
                          ))}
                        </Select>
                        <Input
                          disabled={isDelete}
                          defaultValue={label}
                          style={{ width: 200, marginLeft: 5 }}
                          onChange={(e) => setLabel(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('maxLength10Char')}
                          addonBefore={t('label')}
                        />
                      </Space>
                    )}

                    {/* Float */}
                    <Radio value="float">{t('float')}</Radio>
                    {type === 'float' && (
                      <Space style={{ marginLeft: 24 }}>
                        <Select
                          defaultValue={number}
                          disabled={isDelete}
                          style={{ width: 100 }}
                          onChange={(e) => setNumber(e)}
                          defaultOpen
                          status={status}
                        >
                          {[...Array(16)].map((item, index) => (
                            <Option
                              key={index}
                              value={index + 1}
                              title={index + 1}
                              disabled={(isDraw
                                ? arrMachine
                                : dataMachineDiagram
                              )?.find(
                                (item) =>
                                  item.type === 'float' &&
                                  item.number === index + 1
                              )}
                            />
                          ))}
                        </Select>
                        <Input
                          disabled={isDelete}
                          defaultValue={label}
                          style={{ width: 200, marginLeft: 5 }}
                          onChange={(e) => setLabel(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('maxLength10Char')}
                          addonBefore={t('label')}
                        />
                      </Space>
                    )}

                    {/* Vf */}
                    <Radio value="vf">{t('vf')}</Radio>
                    {type === 'vf' && (
                      <Space style={{ marginLeft: 24 }}>
                        <Select
                          defaultValue={number}
                          disabled={isDelete}
                          style={{ width: 100 }}
                          onChange={(e) => setNumber(e)}
                          defaultOpen
                          status={status}
                        >
                          {[...Array(16)].map((item, index) => (
                            <Option
                              key={index}
                              value={index + 1}
                              title={index + 1}
                              disabled={(isDraw
                                ? arrMachine
                                : dataMachineDiagram
                              )?.find(
                                (item) =>
                                  (item.type === 'pump' ||
                                    item.type === 'vf' ||
                                    item.type === 'van') &&
                                  item.number === index + 1
                              )}
                            />
                          ))}
                        </Select>
                        <InputNumber
                          disabled={isDelete}
                          status={status}
                          placeholder={t('enter-frequency')}
                          defaultValue={
                            (isEdit || isDelete) &&
                            inverter[editPoint[0].number - 1]
                          }
                          style={{ width: 80 }}
                          size="middle"
                          min={0}
                          onChange={(e) => setFrequency(e)}
                        />
                        <Input
                          disabled={isDelete}
                          defaultValue={label}
                          style={{ width: 200, marginLeft: 5 }}
                          onChange={(e) => setLabel(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('maxLength10Char')}
                          addonBefore={t('label')}
                        />
                      </Space>
                    )}

                    {/*  Pt */}
                    <Radio value="pt">{t('pt')}</Radio>
                    {type === 'pt' && (
                      <Space style={{ marginLeft: 24 }}>
                        <Select
                          defaultValue={number}
                          disabled={isDelete}
                          style={{ width: 100 }}
                          onChange={(e) => handleSelected(e)}
                          defaultOpen
                          status={status}
                        >
                          {[...Array(16)].map((item, index) => (
                            <Option
                              key={index}
                              value={index + 1}
                              title={index + 1}
                              disabled={(isDraw
                                ? arrMachine
                                : dataMachineDiagram
                              )?.find(
                                (item) =>
                                  item.type === 'pt' &&
                                  item.number === index + 1
                              )}
                            />
                          ))}
                        </Select>
                        <Input
                          disabled={isDelete}
                          defaultValue={label}
                          style={{ width: 150, marginLeft: 24 }}
                          onChange={(e) => setLabel(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('maxLength10Char')}
                          addonBefore={t('label')}
                        />
                        <Input
                          disabled={isDelete}
                          defaultValue={unit}
                          style={{ width: 150, marginLeft: 24 }}
                          onChange={(e) => setUnit(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('unit')}
                          addonBefore={t('unit')}
                        />
                      </Space>
                    )}

                    {/* Light */}
                    <Radio value="light">{t('light')}</Radio>
                    {type === 'light' && (
                      <Space style={{ marginLeft: 24 }}>
                        <Select
                          defaultValue={number}
                          disabled={isDelete}
                          style={{ width: 100 }}
                          onChange={(e) => handleSelected(e)}
                          defaultOpen
                          status={status}
                        >
                          {[...Array(16)].map((item, index) => (
                            <Option
                              key={index}
                              value={index + 1}
                              title={index + 1}
                              disabled={(isDraw
                                ? arrMachine
                                : dataMachineDiagram
                              )?.find(
                                (item) =>
                                  item.type === 'light' &&
                                  item.number === index + 1
                              )}
                            />
                          ))}
                        </Select>
                        <Input
                          disabled={isDelete}
                          defaultValue={label}
                          style={{ width: 200, marginLeft: 24 }}
                          onChange={(e) => setLabel(e.target.value)}
                          status={status}
                          maxLength={10}
                          placeholder={t('maxLength10Char')}
                          addonBefore={t('label')}
                        />
                      </Space>
                    )}
                  </Space>
                </Radio.Group>
              </Row>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" title={t('cancel')} onClick={handleClose}>
          <X />
        </Button>
        {isDelete ? (
          <Button
            variant="danger"
            title={t('delete')}
            onClick={handleSaveMachine}
          >
            <Trash2 />
          </Button>
        ) : (
          <Button
            variant="success"
            title={t('save')}
            onClick={handleSaveMachine}
          >
            <Save />
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDiagram;
